export default __webpack_public_path__ + "static/national-winner-b8cfee0458c61bfa41eac83b413b3927.png";